import React from "react";

const TournamentResultsError = ({ error, onRetry }) => {
  return (
    <section
      className="card-board overflow-hidden"
      role="alert"
      aria-label="Error loading standings"
      aria-live="assertive"
    >
      <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
        <h1 className="font-display font-bold text-xl text-brand-cream tracking-tight">
          Board
        </h1>
        <p className="text-sm text-brand-mist mt-1">
          Places from posted scores.
        </p>
      </div>
      <div className="p-8 text-center">
        <div className="max-w-md mx-auto">
          <h3 className="heading-display text-lg mb-2">Could not load standings</h3>
          <p className="text-brand-muted mb-4">
            {error?.message ||
              "There was a problem loading the standings."}
          </p>
          <button
            onClick={onRetry}
            className="btn-brand"
            aria-label="Retry loading standings"
            title="Click to try loading the standings again"
          >
            Try again
          </button>
        </div>
      </div>

      {/* Screen reader announcement */}
      <div className="sr-only" aria-live="assertive">
        Error loading standings.{" "}
        {error?.message ||
          "There was a problem loading the standings."}{" "}
        Use the Try Again button to attempt loading the standings again.
      </div>
    </section>
  );
};

export default TournamentResultsError;
